import React, {forwardRef} from 'react';
import {Avatar} from "@material-ui/core";
import {useSelector} from "react-redux";
import {selectUser} from "../../../features/loginSlice";
import "../../../styles/FormMessage.css"
import {selectChatId} from "../../../features/chatSlice";
import db from "../../../firebase";



const FormMessage = forwardRef(({
        id, contents: {
        timestamp,
        displayName,
        email,
        message,
        photo,
        uid
    }
    }, ref) => {
    const user = useSelector(selectUser)
    const chatId = useSelector(selectChatId)





    const handleDel = () => {
        db.collection("chats")
            .doc(chatId)
            .collection('messages')
            .doc(id)
            .delete().then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
    }


    return (
        <div onClick={handleDel} ref={ref}
             className={`message ${user.email === email &&
             "another_user"}`}>

            <Avatar className="message_photo" src={photo}/>
            <p>{message}
                {/*<DeleteIcon />*/}
            </p>

            {/*Играем с временем*/}
            <small>{new Date(timestamp?.toDate()).toLocaleTimeString()}

            </small>
        </div>
    );
})

export default FormMessage;
